export default __webpack_public_path__ + "images/Schuette_grau_Mission.webp?3bc17e9936fa2af9af81314b55164020";